export default __webpack_public_path__ + "static/media/camera.b15b3244.svg";